import { useState, useEffect, useCallback, useRef } from 'react';
import socketClient, { CONNECTION_STATES } from '../socket';

/**
 * Hook that manages the socket lifecycle at the organization level.
 * Initialize once when user enters an org route, disconnect when they leave.
 */
const useSocketConnection = (organizationId) => {
  const [connectionState, setConnectionState] = useState(socketClient.getConnectionState());
  const initialized = useRef(false);

  useEffect(() => {
    if (!organizationId || initialized.current) return;

    initialized.current = true;
    socketClient.setOrganizationId(organizationId);
    socketClient.initSocket();

    const unsubscribe = socketClient.onStateChange((newState) => {
      setConnectionState(newState);
    });

    return () => {
      unsubscribe();
      initialized.current = false;
    };
  }, [organizationId]);

  const reconnect = useCallback(() => {
    socketClient.resetRetries();
    socketClient.initSocket();
  }, []);

  return {
    connectionState,
    isConnected: connectionState === CONNECTION_STATES.CONNECTED,
    isReconnecting: connectionState === CONNECTION_STATES.RECONNECTING,
    isDisconnected: connectionState === CONNECTION_STATES.DISCONNECTED,
    reconnect,
  };
};

export default useSocketConnection;
